export default import.meta.ROLLUP_FILE_URL_rEXO1PbWHyczcnmoo2G9Bw